import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const apiPost = axios.create({
  baseURL: process.env.REACT_APP_API,
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const statusCode = error.response.status;

      if (statusCode === 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('idToken');
        localStorage.removeItem('refreshToken');
        sessionStorage.clear();
        window.location.href = '/';
      }
    } else {
      console.error('Erro na requisição', error);
    }

    return Promise.reject(error);
  },
);
